import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { BlogBlock } from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import { backgroundColor } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundColor";
import { backgroundImage } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundImage";
import { margin } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/margin";
import { padding } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/padding";
import {
  DesignProp,
  GeneralProp,
  MarginsProp,
  PaddingsProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";
import { primaryBlockDefaultStyles } from "../../Homepage/constants";
import { BlogListingBlock1 as Block } from "./BlogListingBlock1";
import { defaultData } from "./BlogListingBlock1DefaultData";
import imagePreview from "./blog_listing_block_1_preview.png";

export const BlogListingBlock1: BlockExport = {
  type: "component",
  Block,
  imagePreview: {
    type: "image-url",
    lg: imagePreview,
  },
  defaultData,
  meta: {
    name: "BlogListing Block 1",
    nameI18n: "builder_ui.block_type.blog_listing.block_1",
    version: 1,
    category: [BlogBlock],
    props: {
      content: {
        name: "Content",
        nameI18n: "builder_ui.prop_type.content",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
        type: "children",
      },
      items: {
        name: "Items",
        nameI18n: "builder_ui.prop_type.items",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
        type: "children",
      },
      styles: {
        name: "Styles",
        nameI18n: "builder_ui.prop_type.styles",
        prop: "styles",
        attributes: {
          backgroundColor: {
            ...backgroundColor,
            category: [DesignProp, GeneralProp],
            defaultValue: primaryBlockDefaultStyles.backgroundColor,
          },
          backgroundImage: {
            ...backgroundImage,
            category: [DesignProp, GeneralProp],
          },
          padding: {
            ...padding,
            category: [DesignProp, PaddingsProp],
            defaultValue: {
              paddingTop: "20",
              paddingBottom: "20",
              paddingLeft: "20",
              paddingRight: "20",
            },
          },
          margin: {
            ...margin,
            category: [DesignProp, MarginsProp],
            defaultValue: primaryBlockDefaultStyles.margin,
          },
        },
        type: "styles",
      },
    },
  },
};
